import React, { Component } from 'react';
import ImageSliderArrow from './image-slider-arrow';
import ImageSliderItem from './image-slider-item';

import './image-slider.css';

/**
* Mostly this works by creating a duplicated element of the full width image slider in front of the max width image slider which handles the scroll bar
* Essentially when the scroll bar is moved, it moves the clone in front.
* Clone in front is to handle hovering of elements showing shadow correctly, but also for mouse dragging scroll.
* 
* Props:
* data - an array / array of arrays - containing the inner data of the element.
* title - the title of the element which shows above the element for now, this could change at a later date depending if the component itself needs to adapt.
          kept seperate from uniqueID for this reason, althought generally they can be the same.
* rows - a number of rows that wish to be shown.
*/

class ImageSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      cloneLeft: 0,
      leftArrow: false,
      rightArrow: true,
    };
  }

  toggleScrollArrows = () => {
    // Check if the scroll bar is at the start or end of the scroll track
    // Removes left or right arrow depending where the scroll bar is on the track
    // If scroll bar is at the start, remove left arrow as the scroll bar can not go any further left
    // If scroll bar is at the end, remove right arrow as the scroll bar can not go any further right
    let scrollLeft = this.refs.slider.scrollLeft;
    let scrollWidth = this.refs.slider.scrollWidth;
    let clientWidth = this.refs.slider.clientWidth;
    var maxScrollLeft = scrollWidth - clientWidth;

    this.setState({
      leftArrow: true,
      rightArrow: true
    }, () => {
      if (maxScrollLeft === 0) {
        this.setState({
          rightArrow: false,
        })
      }

      if (scrollLeft === 0) {
        this.setState({
          leftArrow: false
        })
      } 
      
      if (scrollLeft === maxScrollLeft) {
        this.setState({
          rightArrow: false,
        })
      } 
    })
  }

  handleScroll = (e) => {
    e.preventDefault();

    this.toggleScrollArrows();
    let scrollLeft = this.refs.slider.scrollLeft;
    this.setState({
      cloneLeft: -scrollLeft
    })
  }

  handleArrowScroll = direction => {
    // 342 chosen as the max image size according to specifications is 334px + 4 pixels each side for margin = 334px + 8px = 342.
    if (direction == 'right') {
      this.refs.slider.scrollLeft += 342;
    } else if (direction == 'left') {
      this.refs.slider.scrollLeft -= 342;
    }
  }

  renderItems = () => {
    // Product get passed through as an object of objects
    let data;
    if (typeof this.props.data === 'object' && this.props.data !== null) {
       data = Object.keys(this.props.data).map(key => {
        return this.props.data[key];
      })
    } else {
      data = this.props.data;
    }
    
    // Used for handling multiple rows, essentially we split the data into differen array stacks based on the modulo value of the index.
    // We then chunk the array at the start to ensure the ordering is correct.
    // 1 2 3 4 5 6 7 8
    // becomes
    // 1 3 5 7
    // 2 4 6 8
    // Otherwise we just use the data as is

    let rowArray = [];

    if (this.props.rows > 1 && data.length > 6) {
      for (let i = 0; i < this.props.rows; i++) {
        rowArray.unshift(data.filter(item => data.indexOf(item) % this.props.rows - i));

        if (i == this.props.rows - 1) {
          this.setState({
            data: rowArray
          }, () => {
            this.toggleScrollArrows();
          })
        }
      }
    } else {
      this.setState({
        data: data
      }, () => {
        this.toggleScrollArrows();
      })
    }
  }

  componentDidMount = () => {
    this.renderItems();
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.data !== this.props.data) {
      this.renderItems();
    }
  }

  render() {
    const { isBluBar } = this.props;
    
    return (
      <div className="slider-outer-container">
        {this.props.title &&
          <div className="slider-title-wrapper">
            <h2>{this.props.title}</h2>
          </div>
        }

        <div className="slider-wrapper">
          <div
            className="slider-clone"
            id='slider-clone'
            style={{ left: this.state.cloneLeft }}>
            {(this.props.rows > 1 && this.props.data.length > 6) ? (
              this.state.data.map((row) => (
                <div>
                  {row.map((item, key) => (
                    <ImageSliderItem key={key} inner={item.inner} />
                  ))}
                </div>
              ))
            ) : (
              this.state.data.map((item, key) => (
                <ImageSliderItem key={key} inner={item.inner} />
              ))
            )}
          </div>
          <div
            ref='slider'
            className="slider-container"
            onScroll={(e) => this.handleScroll(e)}
            id='slider-container' >
            {(this.props.rows > 1 && this.props.data.length > 6) ? (
              this.state.data.map((row) => (
                <div>
                  {row.map((item, key) => (
                    <ImageSliderItem key={key} inner={item.inner} />
                  ))}
                </div>
              ))
            ) : (
              this.state.data.map((item, key) => (
                <ImageSliderItem key={key} inner={item.inner} />
              ))
            )}
          </div>
        </div>

        {this.state.leftArrow &&
          <ImageSliderArrow direction='left' handleArrowScroll={this.handleArrowScroll} />
        }
        {this.state.rightArrow &&
          <ImageSliderArrow direction='right' handleArrowScroll={this.handleArrowScroll} />
        }
      </div>
    )
  }
}

export default ImageSlider;



// WEBPACK FOOTER //
// ./src/components/common/image-slider/image-slider.jsx